(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_81563bf"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ai-gallery-carousel')) return;

    const MQ_TABLET = '(min-width: 750px)';
    const MQ_DESKTOP = '(min-width: 990px)';

    class AiGalleryCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ai-gc__track');
        if (!this.track) return;

        this.prevBtn = this.querySelector('[data-gc-prev]');
        this.nextBtn = this.querySelector('[data-gc-next]');
        this.dotsEl = this.querySelector('[data-gc-dots]');
        this.originals = Array.from(this.track.querySelectorAll('.ai-gc__slide')).filter(
          (s) => !s.classList.contains('is-clone')
        );

        const d = this.dataset;
        const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = d.autoplay === 'true' && !reduceMotion;
        this.delay = Math.max(parseInt(d.autoplaySpeed, 10) || 3000, 500);
        this.infinite = d.infinite === 'true';
        this.speed = parseInt(d.speed, 10) || 500;

        this.pos = 0;
        this.busy = false;
        this.dragging = false;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.timer = null;
        this.settleTimer = null;
        this.built = false;

        if (!this.bound) {
          this.bind();
          this.bound = true;
        }

        // Re-layout only when a breakpoint is actually crossed.
        // (window "resize" fires constantly on mobile as the URL bar shows/hides.)
        this.mqs = [matchMedia(MQ_TABLET), matchMedia(MQ_DESKTOP)];
        this.onBreakpoint = () => this.build();
        this.mqs.forEach((mq) => mq.addEventListener('change', this.onBreakpoint));

        this.onVisibility = () => this.syncAutoplay();
        document.addEventListener('visibilitychange', this.onVisibility);

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            this.syncAutoplay();
          });
          this.io.observe(this);
        }

        this.build();
      }

      disconnectedCallback() {
        if (!this.mqs) return;
        this.stop();
        clearTimeout(this.settleTimer);
        this.mqs.forEach((mq) => mq.removeEventListener('change', this.onBreakpoint));
        document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.io) this.io.disconnect();
      }

      /* ---------- one-time listeners ---------- */

      bind() {
        this.prevBtn?.addEventListener('click', () => this.step(-1));
        this.nextBtn?.addEventListener('click', () => this.step(1));

        this.dotsEl?.addEventListener('click', (e) => {
          const dot = e.target.closest('[data-gc-dot]');
          if (dot) this.goTo(Number(dot.dataset.gcDot));
        });

        this.track.addEventListener('transitionend', (e) => {
          if (e.target === this.track && e.propertyName === 'transform') this.settle();
        });

        this.track.addEventListener('dragstart', (e) => e.preventDefault());
        this.track.addEventListener('pointerdown', (e) => this.onDown(e));
        this.track.addEventListener('pointermove', (e) => this.onMove(e));
        this.track.addEventListener('pointerup', (e) => this.onUp(e));
        this.track.addEventListener('pointercancel', (e) => this.onUp(e));

        // Hover-pause for real mice only (touch "hover" would freeze autoplay forever)
        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') { this.hovered = true; this.syncAutoplay(); }
        });
        this.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'mouse') { this.hovered = false; this.syncAutoplay(); }
        });
        this.addEventListener('focusin', () => { this.focused = true; this.syncAutoplay(); });
        this.addEventListener('focusout', () => { this.focused = false; this.syncAutoplay(); });
      }

      /* ---------- layout ---------- */

      getCols() {
        const d = this.dataset;
        const pick = (v, fallback) => Math.max(parseInt(v, 10) || fallback, 1);
        if (this.mqs[1].matches) return pick(d.desktopSlides, 3);
        if (this.mqs[0].matches) return pick(d.tabletSlides, 2);
        return pick(d.mobileSlides, 1);
      }

      build() {
        const keepIndex = this.built ? this.index() : 0;

        this.stop();
        clearTimeout(this.settleTimer);
        this.busy = false;
        this.track.querySelectorAll('.is-clone').forEach((el) => el.remove());

        const n = this.originals.length;
        this.cols = this.getCols();
        this.isStatic = n <= this.cols; // covers 0, 1 or fewer-than-columns images
        this.loop = !this.isStatic && this.infinite;
        this.max = Math.max(n - this.cols, 0);

        this.classList.toggle('is-static', this.isStatic);
        this.style.setProperty('--gc-static-count', n);

        if (this.dotsEl) this.dotsEl.innerHTML = '';
        this.dots = [];
        this.built = true;

        if (this.isStatic) {
          this.pos = 0;
          this.render(false);
          return;
        }

        if (this.loop) {
          const clone = (el) => {
            const c = el.cloneNode(true);
            c.classList.add('is-clone');
            c.setAttribute('aria-hidden', 'true');
            return c;
          };
          this.track.prepend(...this.originals.slice(-this.cols).map(clone));
          this.track.append(...this.originals.slice(0, this.cols).map(clone));
        }

        this.pos = this.loop ? this.cols + keepIndex : Math.min(keepIndex, this.max);
        this.buildDots();
        this.render(false);
        this.updateUI();
        this.syncAutoplay();
      }

      buildDots() {
        if (!this.dotsEl) return;
        const count = this.loop ? this.originals.length : this.max + 1;
        const frag = document.createDocumentFragment();
        for (let i = 0; i < count; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ai-gc__dot';
          dot.dataset.gcDot = i;
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          frag.appendChild(dot);
          this.dots.push(dot);
        }
        this.dotsEl.appendChild(frag);
      }

      /* ---------- movement ---------- */

      // Logical (0-based) index of the first visible original slide
      index() {
        const n = this.originals.length;
        return this.loop ? (((this.pos - this.cols) % n) + n) % n : this.pos;
      }

      // % of the track width = one slide width, so no pixel measuring or resize math is needed
      render(animate, dx = 0) {
        this.track.style.transition = animate ? '' : 'none';
        this.track.style.transform = `translate3d(calc(${(-this.pos * 100) / this.cols}% + ${dx}px), 0, 0)`;
      }

      move(target) {
        const changed = target !== this.pos;
        this.pos = target;
        this.render(true);
        if (changed) {
          this.busy = true;
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settle(), this.speed + 80); // safety net
        }
        this.updateUI();
      }

      step(dir) {
        if (this.isStatic || this.busy) return false;
        const target = this.pos + dir;
        if (!this.loop && (target < 0 || target > this.max)) return false;
        this.move(target);
        this.restartAutoplay();
        return true;
      }

      goTo(i) {
        if (this.isStatic || this.busy) return;
        this.move(this.loop ? i + this.cols : i);
        this.restartAutoplay();
      }

      // After a slide animation: silently jump from a clone back to the real slide
      settle() {
        clearTimeout(this.settleTimer);
        this.busy = false;
        if (!this.loop) return;
        const n = this.originals.length;
        let p = this.pos;
        if (p >= n + this.cols) p -= n;
        else if (p < this.cols) p += n;
        if (p !== this.pos) {
          this.pos = p;
          this.render(false);
          void this.track.offsetWidth; // flush so the next animated move isn't swallowed
        }
      }

      updateUI() {
        const i = this.index();
        this.dots.forEach((dot, k) => {
          const on = k === i;
          dot.classList.toggle('active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (!this.loop) {
          if (this.prevBtn) this.prevBtn.disabled = this.pos <= 0;
          if (this.nextBtn) this.nextBtn.disabled = this.pos >= this.max;
        } else {
          if (this.prevBtn) this.prevBtn.disabled = false;
          if (this.nextBtn) this.nextBtn.disabled = false;
        }
      }

      /* ---------- drag / swipe ---------- */

      onDown(e) {
        if (this.isStatic || this.busy) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        this.dragging = true;
        this.startX = e.clientX;
        this.dx = 0;
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture?.(e.pointerId);
        this.syncAutoplay();
      }

      onMove(e) {
        if (!this.dragging) return;
        this.dx = e.clientX - this.startX;
        this.render(false, this.dx);
      }

      onUp(e) {
        if (!this.dragging) return;
        this.dragging = false;
        this.track.classList.remove('is-dragging');

        const dx = this.dx;
        this.dx = 0;
        const threshold = Math.min(50, (this.originals[0]?.offsetWidth || 250) * 0.2);

        if (e.type !== 'pointercancel' && Math.abs(dx) > threshold && this.step(dx < 0 ? 1 : -1)) return;

        this.render(true); // not enough movement (or at an edge): snap back
        this.syncAutoplay();
      }

      /* ---------- autoplay ---------- */

      tick() {
        if (!this.loop && this.pos >= this.max) {
          if (this.busy) return;
          this.move(0); // non-infinite: rewind to start
        } else {
          this.step(1);
        }
      }

      syncAutoplay() {
        const shouldRun =
          this.autoplay &&
          !this.isStatic &&
          this.visible &&
          !document.hidden &&
          !this.hovered &&
          !this.focused &&
          !this.dragging;

        if (shouldRun && !this.timer) {
          this.timer = setInterval(() => this.tick(), this.delay);
        } else if (!shouldRun) {
          this.stop();
        }
      }

      restartAutoplay() {
        this.stop();
        this.syncAutoplay();
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('ai-gallery-carousel', AiGalleryCarousel);
  })();
  } catch(e) { console.error(e); }
})();

})();
